import {Component, ViewChild} from '@angular/core';
import {
  ZoneDeStockageSavedSupplier,
  ZonesDeStockageService
} from '../../core/services/entities/zones-de-stockage.service';
import {HELP_FOLDERS, MSG_KEY, MSG_SEVERITY} from "../../core/constants";
import {Subscription} from "rxjs";
import {ZoneDeStockageDTO} from "../../core/dtos/zone-de-stockage-dto";
import {Auth2Service} from "../../core/services/security/auth2.service";
import {InternationalizationService} from "../../core/services/i8n/i8n.service";
import {GraphQLService} from "../../core/services/technique/graphql.service";
import {UtilsService} from "../../core/utils/utils.service";
import {ToastService} from "../../core/services/technique/toast.service";
import {ResponseWrapper} from "../../core/suppliers/wrappers/response-wrapper";
import {IsDeletableObject} from "../../core/models/is-deletable-object";
import {confirm} from "devextreme/ui/dialog";
import {saveAs} from "file-saver";
import {DxTooltipComponent} from "devextreme-angular";
import {ButtonThemeEnum} from '../../shared/ui/button/button-theme-enum';

@Component({
    selector: 'yo-zones-de-stockage',
    templateUrl: './zones-de-stockage.component.html',
    styleUrls: ['./zones-de-stockage.component.scss'],
    standalone: false
})
export class ZonesDeStockageComponent {
  public readonly ButtonThemeEnum = ButtonThemeEnum;

  @ViewChild("importTooltip") importTooltip: DxTooltipComponent;

  subLog: Subscription;
  subZoneDeStockageSaved: Subscription;
  subZonesDeStockage: Subscription;

  logged: boolean = false;

  zonesDeStockage: ZoneDeStockageDTO[] = [];

  selectedRows: number[] = [];
  errors: any[] = [];

  displayImportPopupErrors: boolean = false;
  displayDeletePopupErrors: boolean = false;

  pathHelpFile: string = HELP_FOLDERS.REFERENTIEL + '/zones-de-stockage/zones-de-stockage';

  constructor(private auth2Svc: Auth2Service,
              private i8nSvc: InternationalizationService,
              private graphQlSvc: GraphQLService,
              public utilsSvc: UtilsService,
              public zonesDeStockageSvc: ZonesDeStockageService,
              public toastSvc: ToastService) {
  }

  ngOnInit() {
    this.initLoggedSubscription();
    this.initZonesDeStockageSubscription();
    this.initZoneDeStockageSavedSubscription();
  }

  ngOnDestroy(): void {
    this.utilsSvc.unsubscribe(this.subLog);
    this.utilsSvc.unsubscribe(this.subZoneDeStockageSaved);
    this.utilsSvc.unsubscribe(this.subZonesDeStockage);
  }

  initLoggedSubscription = (): void => {
    this.subLog = this.auth2Svc.isLoggedIn$
      .subscribe(res => this.logged = res);
  }

  initZonesDeStockageSubscription = (): void => {
    const idsSites: number[] = this.auth2Svc.utilisateur.sites.map(s => s.id);
    this.subZonesDeStockage = this.graphQlSvc.sendQuery(`
      {
        allZonesDeStockage(filters: {
          siteIds: [${idsSites}]
        }) {
            id,
            code,
            libelle,
            actif,
            site {
                id,
                libelle,
            },
        }
      }
    `)
      .subscribe((response: any) => {
        console.log(response.allZonesDeStockage);
        this.zonesDeStockage = response.allZonesDeStockage;
      });
  }

  initZoneDeStockageSavedSubscription = (): void => {
    this.subZoneDeStockageSaved = this.zonesDeStockageSvc.zoneDeStockageSaved$
      .subscribe((response: ZoneDeStockageSavedSupplier) => {
        if (response.isUpdate) {
          const idx: number = this.zonesDeStockage.findIndex(zoneDeStockage => zoneDeStockage.id === response.zoneDeStockage.id);
          this.zonesDeStockage[idx] = response.zoneDeStockage;
        } else {
          this.zonesDeStockage.push(response.zoneDeStockage);
        }
      });
  };

  openDialogEdition = (zoneDeStockage: ZoneDeStockageDTO): void => {
    this.zonesDeStockageSvc.announceOpenDialogEdition(zoneDeStockage);
  };

  calculateSiteValue = (zoneDeStockage: ZoneDeStockageDTO): string => {
    return zoneDeStockage?.site?.libelle
  };

  exportXslx = () => {
    this.zonesDeStockageSvc.exportZoneDeStockageByFilters(this.selectedRows).subscribe(response => {
      const filename = `zones-de-stockage-export-${new Date().getTime()}.xlsx`;
      const blob = new Blob([response], {type: 'application/vnd.ms-excel'});
      this.selectedRows = [];
      saveAs(blob, filename);
    });
  }

  importXslx = async ($event: any) => {
    this.errors = [];
    if ($event.target.files && $event.target.files.length) {
      const file: File = $event.target.files[0];
      this.zonesDeStockageSvc.importZoneDeStockageFromXlsx(file)
        .subscribe(response => {
          const res: any = response.one;
          if (res.allElementsImported)
            this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, `Le fichier a été importé avec succès`);
          else {
            for (const item of Object.entries(res.reports)) {
              let values: any[] = Array.of(item[1]);
              const labelsError: any[] = values.map(val => val.map(v => this.i8nSvc.getLabelFromCode(v.code, v.args.split(','))).join(', '));
              this.errors.push({infosLine: item[0], labelsError});
            }
          }
          for (const item of res.elementsImported) {
            let index = this.zonesDeStockage.findIndex(zoneDeStockage => zoneDeStockage.id == item.id);
            if (index >= 0)
              this.zonesDeStockage[index] = item;
            else
              this.zonesDeStockage.push(item)
          }

          if (this.errors != null && this.errors.length > 0)
            this.displayImportErrors();

          $event.target.value = "";
          this.importTooltip.instance.hide();
        });
    }
  }

  displayImportErrors = (): void => {
    this.displayImportPopupErrors = true;
  }

  displayDeleteErrors = (): void => {
    this.displayDeletePopupErrors = true;
  }

  closeErrors = (): void => {
    this.errors = [];
    this.displayImportPopupErrors = false;
    this.displayDeletePopupErrors = false;
  }

  deleteValues = async (): Promise<void> => {
    this.errors = [];
    let idsToDeleteInTable = Object.assign([], this.selectedRows);

    let isDeletionValidated: boolean = await confirm(this.i8nSvc.getLabelFromCode(idsToDeleteInTable.length > 1 ? "CONFIRM_DELETION_PLURAL" : "CONFIRM_DELETION_SINGULAR", null), this.i8nSvc.getLabelFromCode("Suppression", null));

    if (!isDeletionValidated)
      return new Promise(null);

    this.zonesDeStockageSvc.deleteZoneDeStockageByFilters(this.selectedRows).subscribe(response => {
      const res: any = (response as ResponseWrapper<IsDeletableObject>).one;

      if (res) {
        if (res.messagesErrorList && res.messagesErrorList.length > 0) {
          for (const error of res.messagesErrorList) {
            const infosLine: string = this.i8nSvc.getLabelFromCode(error.code, error.args.split(','));
            this.errors.push({infosLine});
            const elementToKeep = this.zonesDeStockage.find(zoneDeStockage => zoneDeStockage.code === error.args);
            idsToDeleteInTable = idsToDeleteInTable.filter(id => elementToKeep.id !== id);
          }
          this.displayDeleteErrors();
        } else {
          this.toastSvc.displayToast(MSG_KEY.ROOT, MSG_SEVERITY.SUCCESS, this.i8nSvc.getLabelFromCode(idsToDeleteInTable.length > 1 ? `ZONE_DE_STOCKAGE_DELETION_COMPLETED_PLURAL` : `ZONE_DE_STOCKAGE_DELETION_COMPLETED_SINGULAR`, null));
        }
        this.zonesDeStockage = this.zonesDeStockage.filter(zoneDeStockage => !idsToDeleteInTable.find(id => id === zoneDeStockage.id));
      }
    });
  }

  canDelete = (): boolean => this.selectedRows.length > 0;

}
